import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadUploaderComponent } from './download-uploader.component';
import { RouterModule } from '@angular/router';
import { FaqComponent } from '../faq/faq.component';
import { ManualComponent } from '../manual/manual.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [ DownloadUploaderComponent, FaqComponent, ManualComponent ],
    imports: [ CommonModule, RouterModule, SharedModule ],
    exports: [ DownloadUploaderComponent, FaqComponent, ManualComponent ],
    providers: [],
})
export class UploaderModule { }
